import { render, staticRenderFns } from "./AddDeliveryZoneView.vue?vue&type=template&id=38025c60"
import script from "./AddDeliveryZoneView.vue?vue&type=script&lang=js"
export * from "./AddDeliveryZoneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports